import { useState} from "react";
import {login} from "../Auth";

export const NonAuth =  () =>{
    const [email, setEmail] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const authUser = ()=>{
        login(email, password)
    }
    return (
        <div className="login-container">
            <div className="login-form">
                <picture className="welcome-pic">
                    <source srcSet="https://fonts.gstatic.com/s/e/notoemoji/latest/1f525/512.webp" type="image/webp"/>
                    <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f525/512.gif" alt="🔥" width="64"
                             height="64"/>
                </picture>

                <div>
                    <label className="login-form-label">Логин</label>
                </div>
                <div>
                    <input type="text" className="login-form-input" value={email}
                           onChange={(e) => setEmail(e.target.value)}/>
                </div>
                <div>
                    <label className="login-form-label">Пароль</label>
                </div>
                <div>
                    <input type="password" className="login-form-input" value={password}
                           onChange={(e) => setPassword(e.target.value)}/>
                </div>
                <div>
                    <button className="submit-button-form" type="submit" onClick={authUser}>Войти</button>
                </div>
            </div>
        </div>
    )
}